<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* Add global styles here if needed */
</style>
